
import {Component, NgZone} from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import {ActivityEventData} from "../event/ActivityEvent";
import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {DebugEvent, DebugCommand} from "../event/DebugEvent";
import {ComponentBase} from "../base/ComponentBase";
import {RaVersion} from "../services/configuration/ra.version";
import {filter} from "rxjs/operators";

@Component({
               selector: "debug-log-modal",
               templateUrl: "./debug-log.modal.component.html",
               styleUrls: ["../message/message.modal.component.css"]
           })
export class DebugLogModalComponent extends ComponentBase {

    private modalType: string = "debuglog";
    public activateModal: boolean = false;

    constructor(
        private eventBus: EventBus,
        private modalConfig: ModalConfig,
        private _ngZone: NgZone,
        private logService: BugsnagLoggingService) {
        super("DebugLogModalComponent");
        this.subscribeObserve();
    }

    private subscribeObserve():void {
        let sub = this.eventBus.pipe(filter((e: DebugEvent) =>
                                           (e.type === DebugEvent.TYPE &&
                                            e.command === DebugCommand.DEBUG_LOG))).subscribe((e: DebugEvent) => {
            this.activateModal = true;
        });
        this.subscriptions.push(sub);
    }

    public close(): void {
        this.activateModal = false;
        this.modalConfig.removeModal(new ActivityEventData({type: this.modalType}));
    }

    public showLog(): string {
        let log = "";
        this._ngZone.run(() => {
            log = this.logService.logBuffer;
        });
        return log;
    }
}
